// Clave de localStorage donde el simulador de captura recuerda la última sucursal usada.
export const LAST_SUCURSAL_KEY = "pos-preview-last-sucursal";
